import { useMemo } from "react";
import { useAssets } from "./use-assets";

export const useAvailableTags = (): {
  availableTags: string[];
  loading: boolean;
  error: string | null;
} => {
  const { data: assets, loading, error } = useAssets();

  const availableTags = useMemo(() => {
    if (!assets) return [];

    const allTags = Array.from(new Set(assets.flatMap((asset) => asset.tags))).sort();

    return allTags;
  }, [assets]);

  return {
    availableTags,
    loading,
    error: error?.message || null,
  };
};
